import { createContext, useContext, useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import 'rsuite/dist/rsuite.css';
import './style/bootstrap.css';
import 'boxicons/css/boxicons.css';
import 'bootstrap-daterangepicker/daterangepicker.css'
import './style/App.css';
import './style/utilities.css';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';
import { ToastContainer } from 'react-toastify';

import Home from './pages/Home';
import Login from './pages/Login';
import PageNotFound from './pages/PageNotFound';


import Module from "./pages/Module/Module"
import AddModule from "./pages/Module/ModuleAdd"
import ViewModule from "./pages/Module/ModuleView"
import EditModule from "./pages/Module/ModuleEdit"

import Role from './pages/Role/Role';
import RoleAdd from './pages/Role/RoleAdd';
import ViewRole from './pages/Role/RoleView';

import User from './pages/Permission/User';
import AddUser from './pages/Permission/UserAdd';
import ViewUser from './pages/Permission/UserView';
import EditUser from './pages/Permission/UserEdit';
import Protected from './Component/Protected.js';
import PrivetRoutes from './Component/PrivetRoutes.js';
import { AuthContext } from './AppContext.jsx';
import ServiceProvider from './pages/ServiceProvider/ServiceProvider.jsx';
import ServiceProviderAdd from './pages/ServiceProvider/ServiceProviderAdd.jsx';
import ServiceProviderView from './pages/ServiceProvider/ServiceProviderView.jsx';
import Country from './pages/CountryList/Country.jsx';
import CountryAdd from './pages/CountryList/CountryAdd.jsx';
import CountryView from './pages/CountryList/CountryView.jsx';
import VPN from './pages/VPN/VPN.jsx';
import VPNAdd from './pages/VPN/VPNAdd.jsx';
import VPNView from './pages/VPN/VPNView.jsx';

export const API = axios.create({ baseURL: process.env.REACT_APP_BASE_URL })


const App = () => {
    const { userPermission, theme, setTheme } = useContext(AuthContext)

    return (
        <>
            <>
                <BrowserRouter>
                    <Routes>
                        <Route element={<Protected />}>
                            <Route path="/" element={<Login />} />
                        </Route>
                        <Route element={<PrivetRoutes />}>
                            <Route path="/Home" element={<Home />} />

                            {userPermission["Country"]?.view == 1 &&
                                <Route path="/country" element={<Country />} />
                            }
                            {userPermission["Country"]?.add == 1 &&
                                <Route path="/country/add" element={<CountryAdd />} />
                            }
                            {userPermission["Country"]?.edit == 1 &&
                                <Route path="/country/edit/:id" element={<CountryAdd />} />
                            }
                            {userPermission["Country"]?.view == 1 &&
                                <Route path="/country/view/:id" element={<CountryView />} />
                            }


                            {userPermission["Service-Provider"]?.view == 1 &&
                                <Route path="/service-provider" element={<ServiceProvider />} />
                            }
                            {userPermission["Service-Provider"]?.add == 1 &&
                                <Route path="/service-provider/add" element={<ServiceProviderAdd />} />
                            }
                            {userPermission["Service-Provider"]?.edit == 1 &&
                                <Route path="/service-provider/edit/:id" element={<ServiceProviderAdd />} />
                            }
                            {userPermission["Service-Provider"]?.view == 1 &&
                                <Route path="/service-provider/view/:id" element={<ServiceProviderView />} />
                            }
                            {userPermission["VPN"]?.view == 1 &&
                                <Route path="/vpn" element={<VPN />} />
                            }
                            {userPermission["VPN"]?.add == 1 &&
                                <Route path="/vpn/add" element={<VPNAdd />} />
                            }
                            {userPermission["VPN"]?.edit == 1 &&
                                <Route path="/vpn/edit/:id" element={<VPNAdd />} />
                            }
                            {userPermission["VPN"]?.view == 1 &&
                                <Route path="/vpn/view/:id" element={<VPNView />} />
                            }


                            <Route path="*" element={<PageNotFound />} />

                            <>
                                <Route path="/module" element={<Module />} />
                                <Route path="/module/add" element={<AddModule />} />
                                <Route path="/module/view/:id" element={<ViewModule />} />
                                <Route path="/module/edit/:id" element={<EditModule />} />

                                <Route path="/role" element={<Role />} />
                                <Route path="/role/add" element={<RoleAdd />} />
                                <Route path="/role/edit/:id" element={<RoleAdd />} />
                                <Route path="/role/view/:id" element={<ViewRole />} />

                                <Route path="/user" element={<User />} />
                                <Route path="/user/add" element={<AddUser />} />
                                <Route path="/user/view/:id" element={<ViewUser />} />
                                <Route path="/user/edit/:id" element={<EditUser />} />
                            </>

                        </Route>
                    </Routes>
                </BrowserRouter>
                <ToastContainer position='bottom-right' autoClose={500} />
            </>
        </>
    )
}

export default App;
